import { axiosInstance } from "./axiosInstance";


export const BankQuestionService = {
    getAll: async (filter) => {
        return await axiosInstance.get('/api/feature/membership/quiz/question', { params: filter });
    },
    create: async (data) => {
        return await axiosInstance.post('/api/feature/membership/quiz/question', data);
    },
    update: async (id, data) => {
        return await axiosInstance.post(`/api/feature/membership/quiz/question/update/${id}`, data);
    },
    delete: async (id) => {
        return await axiosInstance.delete(`/api/feature/membership/quiz/question/delete/${id}`);
    },
    import: async (data) => {
        return await axiosInstance.post('/api/feature/import/question', data);
    },
}